import React from 'react';
import { Platform, View, StyleSheet } from 'react-native';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import HomeStack from './HomeStack';

// Screens
import SettingsScreen from '@/screens/SettingsScreen';
import ChatScreen from '@/screens/ChatScreen';

// Components
import { TabBar } from '@/components';
import { ApplicationSentScreen, MeetingCompletedScreen } from '@/screens';

// Types
export type TabParamList = {
  Home: undefined;
  Chat: undefined;
  Create: undefined;
  Profile: undefined;
  Settings: undefined;
};

const Tab = createBottomTabNavigator<TabParamList>();

// Web-specific tab bar that's not absolutely positioned
const WebTabBar: React.FC<any> = (props) => {
  return (
    <View style={webStyles.tabBarContainer}>
      <TabBar {...props} />
    </View>
  );
};

const TabNavigator: React.FC = () => {
  // On web, we need to handle the tab bar differently due to absolute positioning issues
  const renderTabBar = (props: any) => {
    if (Platform.OS === 'web') {
      return <WebTabBar {...props} />;
    }
    return <TabBar {...props} />;
  };
  
  return (
    <View style={styles.container}>
      <Tab.Navigator
        tabBar={renderTabBar}
        screenOptions={{
          headerShown: false,
          // On web, don't lazy load screens for better UX
          ...(Platform.OS === 'web' ? { lazy: false } : {}),
        }}
      >
        <Tab.Screen name="Home" component={HomeStack} />
        <Tab.Screen name="Chat" component={ChatScreen} />
        <Tab.Screen name="Create" component={ApplicationSentScreen} />
        <Tab.Screen name="Profile" component={MeetingCompletedScreen} />
        <Tab.Screen name="Settings" component={SettingsScreen} />
      </Tab.Navigator>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});

const webStyles = StyleSheet.create({
  tabBarContainer: {
    position: 'relative' as any,
    width: '100%',
  },
});

export default TabNavigator;
